/* sugar:assets/quiz-email.js@2.2.0 */
/* Quiz Email: the typed fields of a quiz (email, first and last name, short and long text). Keyed
   off data attributes only, so one copy serves every field on the page.

   A step is answered once every required field on it that is showing holds a value (a valid
   address, for email). The email field signs the shopper up through Shopify's own hidden customer
   form, tagged with every answer they picked and carrying their name and text answers; when a field
   step still follows it on the shopper's path, the signup waits until they leave the last one. */
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var fields = [];

  function stepOf(root) {
    var page = root.closest('[data-quiz-page], [data-quiz-loading]');
    return page ? page.dataset.quizPage || page.dataset.quizLoading : null;
  }

  function showing(f) {
    return f.root.isConnected && !f.root.closest('[data-quiz-path][hidden]');
  }

  function heading(f) {
    var page = f.root.closest('[data-quiz-page], [data-quiz-loading]');
    var hs = page ? page.querySelectorAll('h1, h2, h3, h4, h5, h6') : [];
    for (var i = 0; i < hs.length; i++) {
      if (!hs[i].closest('[data-quiz-path][hidden]')) return hs[i].textContent.replace(/\s+/g, ' ').trim();
    }
    return f.input.getAttribute('placeholder') || '';
  }

  /* The step's answer: the typed values once every required field showing on it is filled. */
  function syncStep(Q, sectionId) {
    var mine = fields.filter(function (f) { return f.step === sectionId && showing(f); });
    var missing = mine.some(function (f) { return f.required && !f.valid(); });
    var values = mine.filter(function (f) { return f.valid(); }).map(function (f) { return f.value(); });
    var complete = !missing && values.length > 0;
    var was = (Q.answers[sectionId] || []).length > 0;
    if (complete !== was) Q.setAnswers(sectionId, complete ? values : null);
    else if (complete) Q.answers[sectionId] = values;
  }

  function init(root) {
    if (root.dataset.quizEmailBound === '1') return;
    root.dataset.quizEmailBound = '1';

    var Q = window.SugarQuiz;
    var sectionId = stepOf(root);
    var input = root.querySelector('[data-quiz-email-input]');
    if (!Q || !sectionId || !input) return;

    var kind = root.dataset.quizField || 'email';
    var error = root.querySelector('[data-quiz-email-error]');
    var required = root.hasAttribute('data-quiz-email-required');
    if (required) Q.setPageRequired(sectionId, root.dataset.quizEmailRequired);

    var f = {
      root: root,
      input: input,
      kind: kind,
      step: sectionId,
      required: required,
      value: function () { return (input.value || '').trim(); },
      valid: function () {
        var v = f.value();
        return v !== '' && (kind !== 'email' || EMAIL_RE.test(v));
      }
    };
    fields.push(f);

    function changed() {
      if (kind === 'first_name' || kind === 'last_name' || kind === 'email') Q.setField(kind, f.valid() ? f.value() : '');
      if (kind === 'email' && !f.valid()) submitted = false;
      syncStep(Q, sectionId);
    }

    /* Long text grows with what the shopper types. */
    function grow() {
      if (input.tagName !== 'TEXTAREA') return;
      input.style.height = 'auto';
      /* A step that isn't showing has no height to measure; it sizes on the next keystroke. */
      if (input.scrollHeight) input.style.height = input.scrollHeight + 'px';
    }

    input.addEventListener('input', function () {
      grow();
      changed();
      if (error && !error.hidden && f.valid()) error.hidden = true;
    });
    input.addEventListener('blur', function () {
      changed();
      if (kind === 'email' && f.valid()) trySubmit();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || input.tagName === 'TEXTAREA') return;
      e.preventDefault();
      changed();
      if (kind === 'email' && f.valid()) trySubmit();
      Q.next();
    });

    if (error) {
      Q.subscribe(function (q) {
        error.hidden = !(q.validationError === sectionId && !f.valid());
      });
    }

    if (kind !== 'email') return;

    /*
     * The address is posted through Shopify's own hidden customer form so the signup is a real
     * customer record, tagged with every answer the visitor picked along the way. Shopify arms a
     * protected form when a shopper focuses inside it; this one is never focused, so it is armed
     * here and its submit then carries the CAPTCHA token. It posts into a hidden frame, and
     * Shopify's customer_posted=true on the frame's address counts the signup.
     */
    var form = root.querySelector('[data-quiz-email-hidden-form]');
    var submitted = false;
    var held = false;
    var RESUME_KEY = 'quiz-email-resume-' + root.id;
    if (!form) return;

    function armCaptcha(then) {
      var captcha = window.Shopify && window.Shopify.captcha;
      var armed = form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound');
      if (!captcha || typeof captcha.protect !== 'function' || armed) {
        if (then) then();
        return;
      }
      try {
        captcha.protect(form, then);
      } catch (e) {
        if (then) then();
      }
    }

    /*
     * The frame's address says how Shopify answered. Back on the page with customer_posted=true
     * counts the signup. Shopify's own "not a robot" page can't show in a frame, so when Shopify
     * asks for it the quiz keeps its place and answers, the form posts again in the page itself,
     * and the shopper lands back on the same step once Shopify has taken the signup.
     */
    function saveResume() {
      try {
        sessionStorage.setItem(RESUME_KEY, JSON.stringify({ path: location.pathname, answers: Q.answers, fields: Q.fields, step: Q.currentStep, page: Q.pages[Q.currentStep], completed: !!Q.completed }));
      } catch (e) {}
    }

    function postInPage() {
      saveResume();
      // The page stays on screen until Shopify's answer arrives, and the quiz can move on meanwhile
      // (a loading step runs on to the results), so the step is saved again as the page leaves:
      // the shopper comes back where they had got to, results included, not to a loading step
      // that plays again.
      window.addEventListener('pagehide', saveResume, { once: true });
      form.target = '_self';
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else if (form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))) form.submit();
    }

    function watchFrame(frame, done) {
      var settled = false;
      function settle() {
        if (settled) return;
        settled = true;
        var href = '';
        try {
          href = frame.contentWindow.location.href;
        } catch (e) {}
        frame.remove();
        if (!href || href.indexOf('/challenge') !== -1) {
          done('challenge');
          postInPage();
          return;
        }
        done('posted');
        if (href.indexOf('customer_posted=true') !== -1 && Q.quizSessionOnce('_sugar_conv_email_' + Q.analyticsId)) {
          Q.emitQuizEvent('convert', 'email');
        }
      }
      frame.addEventListener('load', settle);
      // A page Shopify won't show in a frame still fires load; this only covers one that never answers
      setTimeout(settle, 30000);
    }

    function fill(name, value) {
      var el = form.querySelector('[data-quiz-email-hidden="' + name + '"]');
      if (!el) return;
      el.value = value || '';
      el.disabled = !value;
    }

    function submitToShopify() {
      if (submitted || !f.valid()) return;
      submitted = true;
      held = false;

      form.querySelector('[data-quiz-email-hidden-email]').value = f.value();

      var tags = form.querySelector('[data-quiz-email-tags]');
      if (tags) {
        var all = tags.defaultValue.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        var add = function (t) {
          t = t.trim();
          if (t && all.indexOf(t) === -1) all.push(t);
        };
        Object.keys(Q.answers).forEach(function (pageId) {
          (Q.answers[pageId] || []).forEach(function (answerId) {
            var el = document.querySelector('[data-answer-id=' + JSON.stringify(String(answerId)) + '][data-answer-tag]');
            if (el) el.dataset.answerTag.split(',').forEach(add);
          });
        });
        (Q.linkTags || []).forEach(add);
        tags.value = all.join(', ');
      }

      /* Names from the quiz's name fields, and every text answer under its step's heading. */
      fill('first_name', Q.fields && Q.fields.first_name);
      fill('last_name', Q.fields && Q.fields.last_name);
      var note = fields
        .filter(function (o) { return (o.kind === 'text' || o.kind === 'textarea') && o.valid() && showing(o); })
        .map(function (o) { return heading(o) + ': ' + o.value(); })
        .join('\n');
      fill('note', note);

      var frame = document.createElement('iframe');
      frame.name = form.getAttribute('target');
      frame.title = '';
      frame.hidden = true;
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      document.body.appendChild(frame);

      var done;
      var posted = new Promise(function (resolve) { done = resolve; });
      if (Q.trackPost) Q.trackPost(posted);

      armCaptcha(function () {
        watchFrame(frame, done);
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else if (form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))) form.submit();
      });
    }

    /* The last step on the shopper's path that still holds a field, so the name typed after the
       address arrives with it. */
    function lastFieldStep() {
      var last = -1;
      fields.forEach(function (o) {
        var i = Q.pages.indexOf(o.step);
        if (i > last && showing(o)) last = i;
      });
      return last;
    }

    function trySubmit() {
      if (submitted || !f.valid()) return;
      if (lastFieldStep() > Q.pages.indexOf(sectionId)) {
        held = true;
        return;
      }
      submitToShopify();
    }

    Q.subscribe(function (q) {
      if (held && (q.completed || q.currentStep > lastFieldStep())) submitToShopify();
    });
    document.addEventListener('sugar:quiz-flush', function () {
      if (held) submitToShopify();
    });

    // Back from Shopify's "not a robot" page: the answers and the step the shopper was on return
    var resume = null;
    try {
      resume = JSON.parse(sessionStorage.getItem(RESUME_KEY) || 'null');
      sessionStorage.removeItem(RESUME_KEY);
    } catch (e) {}
    if (resume && resume.path === location.pathname && typeof resume.step === 'number') {
      var postedBack = /[?&]customer_posted=true/.test(location.search);
      submitted = postedBack;
      setTimeout(function () {
        Object.keys(resume.answers || {}).forEach(function (id) {
          Q.answers[id] = resume.answers[id];
        });
        Object.keys(resume.fields || {}).forEach(function (k) {
          Q.fields[k] = resume.fields[k];
        });
        if (postedBack && Q.quizSessionOnce('_sugar_conv_email_' + Q.analyticsId)) Q.emitQuizEvent('convert', 'email');
        // The answers decide which path's steps and content show, so the steps are rebuilt from
        // them and the shopper's own step is found by its id rather than its old position
        var pageId = resume.page && Q.pageElement(resume.page) ? resume.page : null;
        if (!pageId) {
          var last = Math.max(0, (Q.totalSteps || Q.pages.length) - 1);
          pageId = Q.pages[Math.max(0, Math.min(resume.step, last))];
        }
        Q.syncPagesFromDom(pageId);
        if (typeof Q.prefetchNext === 'function') Q.prefetchNext();
        if (resume.completed && typeof Q.complete === 'function') Q.complete();
        else Q.notify();
      }, 200);
    }
  }

  function scan(scope) {
    var r = scope && scope.querySelectorAll ? scope : document;
    r.querySelectorAll('[data-quiz-email]').forEach(init);
  }

  window.SugarReady(function () {
    scan(document);
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    document.addEventListener('shopify:block:select', function (e) { scan(e.target); });
  });
})();
